(() => {
  if (customElements.get('poyomi-flow')) return;
  class PoyomiFlow extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.choices = [...this.querySelectorAll('[data-flow-choice]')];
      this.panels = [...this.querySelectorAll('[data-flow-panel]')];
      this.lines = [...this.querySelectorAll('[data-flow-line]')];
      if (!this.choices.length) return;
      this.current = 0;
      this.querySelector('.pm-flow-controls').hidden = false;
      this.choices.forEach((button, index) => {
        button.addEventListener('click', () => this.select(index, true), { signal });
        button.addEventListener('keydown', (event) => {
          const movement = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
          if (!movement && event.key !== 'Home' && event.key !== 'End') return;
          event.preventDefault();
          const target = event.key === 'Home' ? 0 : event.key === 'End' ? this.choices.length - 1 : (index + movement + this.choices.length) % this.choices.length;
          this.select(target, true);
          this.choices[target].focus();
        }, { signal });
      });
      this.querySelector('[data-flow-prev]').addEventListener('click', () => this.select(this.current - 1, true), { signal });
      this.querySelector('[data-flow-next]').addEventListener('click', () => this.select(this.current + 1, true), { signal });
      const motion = this.querySelector('[data-flow-motion]');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const syncMotion = () => { if (motion) motion.hidden = this.reduced.matches || this.dataset.motion === 'off'; };
      syncMotion();
      this.reduced.addEventListener('change', syncMotion, { signal });
      if (motion) motion.addEventListener('click', () => {
        const paused = this.classList.toggle('is-paused');
        motion.setAttribute('aria-pressed', String(paused));
        motion.textContent = paused ? 'Animatie hervatten' : 'Animatie pauzeren';
      }, { signal });
      this.observer = new IntersectionObserver((entries) => {
        this.classList.toggle('is-away', !entries[0].isIntersecting);
      }, { threshold: 0 });
      this.observer.observe(this);
      document.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[data-flow-panel]');
        if (panel && this.contains(panel)) this.select(Number(panel.dataset.flowPanel), false);
      }, { signal });
      this.select(0, false);
    }
    select(index, announce) {
      this.current = (index + this.choices.length) % this.choices.length;
      this.dataset.active = String(this.current);
      this.choices.forEach((choice, i) => choice.setAttribute('aria-pressed', String(i === this.current)));
      this.panels.forEach((panel, i) => {
        panel.classList.toggle('is-active', i === this.current);
        panel.hidden = i !== this.current;
      });
      this.lines.forEach((line) => line.classList.toggle('is-active', Number(line.dataset.flowLine) === this.current));
      this.querySelector('[data-flow-count]').textContent = String(this.current + 1).padStart(2, '0');
      if (announce) this.querySelector('.pm-flow-status').textContent = this.panels[this.current].querySelector('h3').textContent + ' ' + this.panels[this.current].querySelector('p').textContent;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  }
  customElements.define('poyomi-flow', PoyomiFlow);
})();
